export default __webpack_public_path__ + "static/media/fiolet_razmer.2d3ddc99.svg";